import http from "../../../request";

export default {
  contacts: async (context) => {
    let response = await http.get("contacts", localStorage.getItem("lang"));
    context.commit("setContacts", response);
  },
  submitContact: async (context, payload) => {
    let formData = new FormData();
    formData.append("name", payload.name);
    formData.append("email", payload.email);
    formData.append("phone", payload.phone);
    formData.append("message", payload.message);
    formData.append('token', payload.token);
    return await http.post("contacts", localStorage.getItem("lang"), formData);
  },
};
